import * as i0 from '@angular/core';
import { Directive, Input, Component, Injectable, inject } from '@angular/core';
import { ReplaySubject, partition, merge, timer } from 'rxjs';
import { switchMap, debounce, distinctUntilChanged, tap, finalize } from 'rxjs/operators';
import { NgStyle, NgComponentOutlet, NgIf, AsyncPipe } from '@angular/common';

/*
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
const _c0 = a0 => ({
  "background-color": a0
});
function NgHttpLoaderComponent_div_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NgHttpLoaderComponent_div_0_sk_cube_grid_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "sk-cube-grid", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("backgroundColor", ctx_r0.backgroundColor);
  }
}
function NgHttpLoaderComponent_div_0_sk_chasing_dots_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "sk-chasing-dots", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("backgroundColor", ctx_r0.backgroundColor);
  }
}
function NgHttpLoaderComponent_div_0_sk_double_bounce_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "sk-double-bounce", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("backgroundColor", ctx_r0.backgroundColor);
  }
}
function NgHttpLoaderComponent_div_0_sk_rotating_plane_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "sk-rotating-plane", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("backgroundColor", ctx_r0.backgroundColor);
  }
}
function NgHttpLoaderComponent_div_0_sk_spinner_pulse_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "sk-spinner-pulse", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("backgroundColor", ctx_r0.backgroundColor);
  }
}
function NgHttpLoaderComponent_div_0_sk_three_bounce_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "sk-three-bounce", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("backgroundColor", ctx_r0.backgroundColor);
  }
}
function NgHttpLoaderComponent_div_0_sk_wandering_cubes_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "sk-wandering-cubes", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("backgroundColor", ctx_r0.backgroundColor);
  }
}
function NgHttpLoaderComponent_div_0_sk_wave_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "sk-wave", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("backgroundColor", ctx_r0.backgroundColor);
  }
}
function NgHttpLoaderComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, NgHttpLoaderComponent_div_0_ng_container_1_Template, 1, 0, "ng-container", 2)(2, NgHttpLoaderComponent_div_0_sk_cube_grid_2_Template, 1, 1, "sk-cube-grid", 3)(3, NgHttpLoaderComponent_div_0_sk_chasing_dots_3_Template, 1, 1, "sk-chasing-dots", 3)(4, NgHttpLoaderComponent_div_0_sk_double_bounce_4_Template, 1, 1, "sk-double-bounce", 3)(5, NgHttpLoaderComponent_div_0_sk_rotating_plane_5_Template, 1, 1, "sk-rotating-plane", 3)(6, NgHttpLoaderComponent_div_0_sk_spinner_pulse_6_Template, 1, 1, "sk-spinner-pulse", 3)(7, NgHttpLoaderComponent_div_0_sk_three_bounce_7_Template, 1, 1, "sk-three-bounce", 3)(8, NgHttpLoaderComponent_div_0_sk_wandering_cubes_8_Template, 1, 1, "sk-wandering-cubes", 3)(9, NgHttpLoaderComponent_div_0_sk_wave_9_Template, 1, 1, "sk-wave", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("opacity", ctx_r0.opacity);
    i0.ɵɵclassProp("backdrop", ctx_r0.backdrop);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(14, _c0, ctx_r0.backdrop ? ctx_r0.backdropBackgroundColor : "transparent"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngComponentOutlet", ctx_r0.entryComponent);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.spinner === ctx_r0.spinkit.skCubeGrid);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.spinner === ctx_r0.spinkit.skChasingDots);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.spinner === ctx_r0.spinkit.skDoubleBounce);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.spinner === ctx_r0.spinkit.skRotatingPlane);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.spinner === ctx_r0.spinkit.skSpinnerPulse);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.spinner === ctx_r0.spinkit.skThreeBounce);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.spinner === ctx_r0.spinkit.skWanderingCubes);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.spinner === ctx_r0.spinkit.skWave);
  }
}
let AbstractLoaderDirective = /*#__PURE__*/(() => {
  class AbstractLoaderDirective {
    backgroundColor;
    static ɵfac = function AbstractLoaderDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AbstractLoaderDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: AbstractLoaderDirective,
      inputs: {
        backgroundColor: "backgroundColor"
      }
    });
  }
  return AbstractLoaderDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
let SkChasingDotsComponent = /*#__PURE__*/(() => {
  class SkChasingDotsComponent extends AbstractLoaderDirective {
    static ɵfac = /* @__PURE__ */(() => {
      let ɵSkChasingDotsComponent_BaseFactory;
      return function SkChasingDotsComponent_Factory(__ngFactoryType__) {
        return (ɵSkChasingDotsComponent_BaseFactory || (ɵSkChasingDotsComponent_BaseFactory = i0.ɵɵgetInheritedFactory(SkChasingDotsComponent)))(__ngFactoryType__ || SkChasingDotsComponent);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SkChasingDotsComponent,
      selectors: [["sk-chasing-dots"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 6,
      consts: [[1, "sk-chasing-dots"], [1, "sk-child", "sk-dot1"], [1, "sk-child", "sk-dot2"]],
      template: function SkChasingDotsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "div", 1)(2, "div", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("colored", !ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
        }
      },
      styles: [".sk-chasing-dots[_ngcontent-%COMP%]{top:50%;margin:auto;width:40px;height:40px;position:relative;text-align:center;animation:_ngcontent-%COMP%_sk-chasingDotsRotate 2s infinite linear}.sk-chasing-dots[_ngcontent-%COMP%]   .sk-child[_ngcontent-%COMP%]{width:60%;height:60%;display:inline-block;position:absolute;top:0;border-radius:100%;animation:_ngcontent-%COMP%_sk-chasingDotsBounce 2s infinite ease-in-out}.sk-chasing-dots[_ngcontent-%COMP%]   .sk-dot2[_ngcontent-%COMP%]{top:auto;bottom:0;animation-delay:-1s}@keyframes _ngcontent-%COMP%_sk-chasingDotsRotate{to{transform:rotate(360deg)}}@keyframes _ngcontent-%COMP%_sk-chasingDotsBounce{0%,to{transform:scale(0)}50%{transform:scale(1)}}"]
    });
  }
  return SkChasingDotsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
let SkCubeGridComponent = /*#__PURE__*/(() => {
  class SkCubeGridComponent extends AbstractLoaderDirective {
    static ɵfac = /* @__PURE__ */(() => {
      let ɵSkCubeGridComponent_BaseFactory;
      return function SkCubeGridComponent_Factory(__ngFactoryType__) {
        return (ɵSkCubeGridComponent_BaseFactory || (ɵSkCubeGridComponent_BaseFactory = i0.ɵɵgetInheritedFactory(SkCubeGridComponent)))(__ngFactoryType__ || SkCubeGridComponent);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SkCubeGridComponent,
      selectors: [["sk-cube-grid"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 10,
      vars: 20,
      consts: [[1, "sk-cube-grid"], [1, "sk-cube", "sk-cube1"], [1, "sk-cube", "sk-cube2"], [1, "sk-cube", "sk-cube3"], [1, "sk-cube", "sk-cube4"], [1, "sk-cube", "sk-cube5"], [1, "sk-cube", "sk-cube6"], [1, "sk-cube", "sk-cube7"], [1, "sk-cube", "sk-cube8"], [1, "sk-cube", "sk-cube9"]],
      template: function SkCubeGridComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "div", 6)(7, "div", 7)(8, "div", 8)(9, "div", 9);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("colored", !ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
        }
      },
      styles: [".sk-cube-grid[_ngcontent-%COMP%]{position:relative;top:50%;width:40px;height:40px;margin:auto}.sk-cube-grid[_ngcontent-%COMP%]   .sk-cube[_ngcontent-%COMP%]{width:33.33%;height:33.33%;float:left;animation:_ngcontent-%COMP%_sk-cubeGridScaleDelay 1.3s infinite ease-in-out}.sk-cube-grid[_ngcontent-%COMP%]   .sk-cube1[_ngcontent-%COMP%]{animation-delay:.2s}.sk-cube-grid[_ngcontent-%COMP%]   .sk-cube2[_ngcontent-%COMP%]{animation-delay:.3s}.sk-cube-grid[_ngcontent-%COMP%]   .sk-cube3[_ngcontent-%COMP%]{animation-delay:.4s}.sk-cube-grid[_ngcontent-%COMP%]   .sk-cube4[_ngcontent-%COMP%]{animation-delay:.1s}.sk-cube-grid[_ngcontent-%COMP%]   .sk-cube5[_ngcontent-%COMP%]{animation-delay:.2s}.sk-cube-grid[_ngcontent-%COMP%]   .sk-cube6[_ngcontent-%COMP%]{animation-delay:.3s}.sk-cube-grid[_ngcontent-%COMP%]   .sk-cube7[_ngcontent-%COMP%]{animation-delay:0s}.sk-cube-grid[_ngcontent-%COMP%]   .sk-cube8[_ngcontent-%COMP%]{animation-delay:.1s}.sk-cube-grid[_ngcontent-%COMP%]   .sk-cube9[_ngcontent-%COMP%]{animation-delay:.2s}@keyframes _ngcontent-%COMP%_sk-cubeGridScaleDelay{0%,70%,to{transform:scaleZ(1)}35%{transform:scale3D(0,0,1)}}"]
    });
  }
  return SkCubeGridComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
let SkDoubleBounceComponent = /*#__PURE__*/(() => {
  class SkDoubleBounceComponent extends AbstractLoaderDirective {
    static ɵfac = /* @__PURE__ */(() => {
      let ɵSkDoubleBounceComponent_BaseFactory;
      return function SkDoubleBounceComponent_Factory(__ngFactoryType__) {
        return (ɵSkDoubleBounceComponent_BaseFactory || (ɵSkDoubleBounceComponent_BaseFactory = i0.ɵɵgetInheritedFactory(SkDoubleBounceComponent)))(__ngFactoryType__ || SkDoubleBounceComponent);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SkDoubleBounceComponent,
      selectors: [["sk-double-bounce"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 6,
      consts: [[1, "sk-double-bounce"], [1, "sk-child", "sk-double-bounce1"], [1, "sk-child", "sk-double-bounce2"]],
      template: function SkDoubleBounceComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "div", 1)(2, "div", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("colored", !ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
        }
      },
      styles: [".sk-double-bounce[_ngcontent-%COMP%]{top:50%;width:40px;height:40px;position:relative;margin:auto}.sk-double-bounce[_ngcontent-%COMP%]   .sk-child[_ngcontent-%COMP%]{width:100%;height:100%;border-radius:50%;background-color:#333;opacity:.6;position:absolute;top:0;left:0;animation:_ngcontent-%COMP%_sk-doubleBounce 2s infinite ease-in-out}.sk-double-bounce[_ngcontent-%COMP%]   .sk-double-bounce2[_ngcontent-%COMP%]{animation-delay:-1s}@keyframes _ngcontent-%COMP%_sk-doubleBounce{0%,to{transform:scale(0)}50%{transform:scale(1)}}"]
    });
  }
  return SkDoubleBounceComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
let SkRotatingPlaneComponent = /*#__PURE__*/(() => {
  class SkRotatingPlaneComponent extends AbstractLoaderDirective {
    static ɵfac = /* @__PURE__ */(() => {
      let ɵSkRotatingPlaneComponent_BaseFactory;
      return function SkRotatingPlaneComponent_Factory(__ngFactoryType__) {
        return (ɵSkRotatingPlaneComponent_BaseFactory || (ɵSkRotatingPlaneComponent_BaseFactory = i0.ɵɵgetInheritedFactory(SkRotatingPlaneComponent)))(__ngFactoryType__ || SkRotatingPlaneComponent);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SkRotatingPlaneComponent,
      selectors: [["sk-rotating-plane"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 2,
      consts: [[1, "sk-rotating-plane", "colored-parent"]],
      template: function SkRotatingPlaneComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
        }
      },
      styles: [".sk-rotating-plane[_ngcontent-%COMP%]{position:relative;top:50%;width:40px;height:40px;margin:auto;animation:_ngcontent-%COMP%_sk-rotatePlane 1.2s infinite ease-in-out}@keyframes _ngcontent-%COMP%_sk-rotatePlane{0%{transform:perspective(120px) rotateX(0) rotateY(0)}50%{transform:perspective(120px) rotateX(-180.1deg) rotateY(0)}to{transform:perspective(120px) rotateX(-180deg) rotateY(-179.9deg)}}"]
    });
  }
  return SkRotatingPlaneComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
let SkSpinnerPulseComponent = /*#__PURE__*/(() => {
  class SkSpinnerPulseComponent extends AbstractLoaderDirective {
    static ɵfac = /* @__PURE__ */(() => {
      let ɵSkSpinnerPulseComponent_BaseFactory;
      return function SkSpinnerPulseComponent_Factory(__ngFactoryType__) {
        return (ɵSkSpinnerPulseComponent_BaseFactory || (ɵSkSpinnerPulseComponent_BaseFactory = i0.ɵɵgetInheritedFactory(SkSpinnerPulseComponent)))(__ngFactoryType__ || SkSpinnerPulseComponent);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SkSpinnerPulseComponent,
      selectors: [["sk-spinner-pulse"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 2,
      consts: [[1, "sk-spinner", "sk-spinner-pulse", "colored-parent"]],
      template: function SkSpinnerPulseComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
        }
      },
      styles: [".sk-spinner-pulse[_ngcontent-%COMP%]{position:relative;top:50%;width:40px;height:40px;margin:auto;border-radius:100%;animation:_ngcontent-%COMP%_sk-pulseScaleOut 1s infinite ease-in-out}@keyframes _ngcontent-%COMP%_sk-pulseScaleOut{0%{transform:scale(0)}to{transform:scale(1);opacity:0}}"]
    });
  }
  return SkSpinnerPulseComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
let SkThreeBounceComponent = /*#__PURE__*/(() => {
  class SkThreeBounceComponent extends AbstractLoaderDirective {
    static ɵfac = /* @__PURE__ */(() => {
      let ɵSkThreeBounceComponent_BaseFactory;
      return function SkThreeBounceComponent_Factory(__ngFactoryType__) {
        return (ɵSkThreeBounceComponent_BaseFactory || (ɵSkThreeBounceComponent_BaseFactory = i0.ɵɵgetInheritedFactory(SkThreeBounceComponent)))(__ngFactoryType__ || SkThreeBounceComponent);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SkThreeBounceComponent,
      selectors: [["sk-three-bounce"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 8,
      consts: [[1, "sk-three-bounce"], [1, "sk-child", "sk-bounce1"], [1, "sk-child", "sk-bounce2"], [1, "sk-child", "sk-bounce3"]],
      template: function SkThreeBounceComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "div", 1)(2, "div", 2)(3, "div", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("colored", !ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
        }
      },
      styles: [".sk-three-bounce[_ngcontent-%COMP%]{top:50%;position:relative;margin:auto;width:80px;text-align:center}.sk-three-bounce[_ngcontent-%COMP%]   .sk-child[_ngcontent-%COMP%]{width:20px;height:20px;border-radius:100%;display:inline-block;animation:_ngcontent-%COMP%_sk-three-bounce 1.4s ease-in-out 0s infinite both}.sk-three-bounce[_ngcontent-%COMP%]   .sk-bounce1[_ngcontent-%COMP%]{animation-delay:-.32s}.sk-three-bounce[_ngcontent-%COMP%]   .sk-bounce2[_ngcontent-%COMP%]{animation-delay:-.16s}@keyframes _ngcontent-%COMP%_sk-three-bounce{0%,80%,to{transform:scale(0)}40%{transform:scale(1)}}"]
    });
  }
  return SkThreeBounceComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
let SkWanderingCubesComponent = /*#__PURE__*/(() => {
  class SkWanderingCubesComponent extends AbstractLoaderDirective {
    static ɵfac = /* @__PURE__ */(() => {
      let ɵSkWanderingCubesComponent_BaseFactory;
      return function SkWanderingCubesComponent_Factory(__ngFactoryType__) {
        return (ɵSkWanderingCubesComponent_BaseFactory || (ɵSkWanderingCubesComponent_BaseFactory = i0.ɵɵgetInheritedFactory(SkWanderingCubesComponent)))(__ngFactoryType__ || SkWanderingCubesComponent);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SkWanderingCubesComponent,
      selectors: [["sk-wandering-cubes"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 6,
      consts: [[1, "sk-wandering-cubes"], [1, "sk-cube", "sk-cube1"], [1, "sk-cube", "sk-cube2"]],
      template: function SkWanderingCubesComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "div", 1)(2, "div", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("colored", !ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
        }
      },
      styles: [".sk-wandering-cubes[_ngcontent-%COMP%]{top:50%;margin:auto;width:40px;height:40px;position:relative}.sk-wandering-cubes[_ngcontent-%COMP%]   .sk-cube[_ngcontent-%COMP%]{width:10px;height:10px;position:absolute;top:0;left:0;animation:_ngcontent-%COMP%_sk-wanderingCube 1.8s ease-in-out -1.8s infinite both}.sk-wandering-cubes[_ngcontent-%COMP%]   .sk-cube2[_ngcontent-%COMP%]{animation-delay:-.9s}@keyframes _ngcontent-%COMP%_sk-wanderingCube{0%{transform:rotate(0)}25%{transform:translate(30px) rotate(-90deg) scale(.5)}50%{transform:translate(30px) translateY(30px) rotate(-179deg)}50.1%{transform:translate(30px) translateY(30px) rotate(-180deg)}75%{transform:translate(0) translateY(30px) rotate(-270deg) scale(.5)}to{transform:rotate(-360deg)}}"]
    });
  }
  return SkWanderingCubesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
let SkWaveComponent = /*#__PURE__*/(() => {
  class SkWaveComponent extends AbstractLoaderDirective {
    static ɵfac = /* @__PURE__ */(() => {
      let ɵSkWaveComponent_BaseFactory;
      return function SkWaveComponent_Factory(__ngFactoryType__) {
        return (ɵSkWaveComponent_BaseFactory || (ɵSkWaveComponent_BaseFactory = i0.ɵɵgetInheritedFactory(SkWaveComponent)))(__ngFactoryType__ || SkWaveComponent);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SkWaveComponent,
      selectors: [["sk-wave"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 6,
      vars: 12,
      consts: [[1, "sk-wave"], [1, "sk-rect", "sk-rect1"], [1, "sk-rect", "sk-rect2"], [1, "sk-rect", "sk-rect3"], [1, "sk-rect", "sk-rect4"], [1, "sk-rect", "sk-rect5"]],
      template: function SkWaveComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 5);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("colored", !ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
        }
      },
      styles: [".sk-wave[_ngcontent-%COMP%]{position:relative;top:50%;margin:auto;width:50px;height:40px;text-align:center;font-size:10px}.sk-wave[_ngcontent-%COMP%]   .sk-rect[_ngcontent-%COMP%]{float:left;margin-right:1px;height:100%;width:6px;display:inline-block;animation:_ngcontent-%COMP%_sk-waveStretchDelay 1.2s infinite ease-in-out}.sk-wave[_ngcontent-%COMP%]   .sk-rect1[_ngcontent-%COMP%]{animation-delay:-1.2s}.sk-wave[_ngcontent-%COMP%]   .sk-rect2[_ngcontent-%COMP%]{animation-delay:-1.1s}.sk-wave[_ngcontent-%COMP%]   .sk-rect3[_ngcontent-%COMP%]{animation-delay:-1s}.sk-wave[_ngcontent-%COMP%]   .sk-rect4[_ngcontent-%COMP%]{animation-delay:-.9s}.sk-wave[_ngcontent-%COMP%]   .sk-rect5[_ngcontent-%COMP%]{animation-delay:-.8s}@keyframes _ngcontent-%COMP%_sk-waveStretchDelay{0%,40%,to{transform:scaleY(.4)}20%{transform:scaleY(1)}}"]
    });
  }
  return SkWaveComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
const Spinkit = {
  skChasingDots: 'sk-chasing-dots',
  skCubeGrid: 'sk-cube-grid',
  skDoubleBounce: 'sk-double-bounce',
  skRotatingPlane: 'sk-rotationg-plane',
  skSpinnerPulse: 'sk-spinner-pulse',
  skThreeBounce: 'sk-three-bounce',
  skWanderingCubes: 'sk-wandering-cubes',
  skWave: 'sk-wave'
};
const SPINKIT_COMPONENTS = [SkCubeGridComponent, SkChasingDotsComponent, SkDoubleBounceComponent, SkRotatingPlaneComponent, SkSpinnerPulseComponent, SkThreeBounceComponent, SkWanderingCubesComponent, SkWaveComponent];
let PendingRequestsInterceptorConfigurer = /*#__PURE__*/(() => {
  class PendingRequestsInterceptorConfigurer {
    _pendingRequests = 0;
    _pendingRequestsStatus$ = new ReplaySubject(1);
    _filteredUrlPatterns = [];
    _filteredMethods = [];
    _filteredHeaders = [];
    _forceByPass = false;
    get pendingRequestsStatus$() {
      return this._pendingRequestsStatus$.asObservable();
    }
    get pendingRequestsStatusSubject$() {
      return this._pendingRequestsStatus$;
    }
    get pendingRequests() {
      return this._pendingRequests;
    }
    set pendingRequests(pendingRequests) {
      this._pendingRequests = pendingRequests;
    }
    get filteredUrlPatterns() {
      return this._filteredUrlPatterns;
    }
    set filteredMethods(httpMethods) {
      this._filteredMethods = httpMethods;
    }
    set filteredHeaders(value) {
      this._filteredHeaders = value;
    }
    set forceByPass(value) {
      this._forceByPass = value;
    }
    shouldBypassUrl(url) {
      return this._filteredUrlPatterns.some(e => {
        return e.test(url);
      });
    }
    shouldBypassMethod(req) {
      return this._filteredMethods.some(e => {
        return e.toUpperCase() === req.method.toUpperCase();
      });
    }
    shouldBypassHeader(req) {
      return this._filteredHeaders.some(e => {
        return req.headers.has(e);
      });
    }
    shouldBypass(req) {
      return this._forceByPass || this.shouldBypassUrl(req.urlWithParams) || this.shouldBypassMethod(req) || this.shouldBypassHeader(req);
    }
    static ɵfac = function PendingRequestsInterceptorConfigurer_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PendingRequestsInterceptorConfigurer)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PendingRequestsInterceptorConfigurer,
      factory: PendingRequestsInterceptorConfigurer.ɵfac,
      providedIn: 'root'
    });
  }
  return PendingRequestsInterceptorConfigurer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
let SpinnerVisibilityService = /*#__PURE__*/(() => {
  class SpinnerVisibilityService {
    pendingRequestsInterceptorConfigurer;
    _visibility$ = new ReplaySubject(1);
    constructor(pendingRequestsInterceptorConfigurer) {
      this.pendingRequestsInterceptorConfigurer = pendingRequestsInterceptorConfigurer;
    }
    get visibility$() {
      return this._visibility$.asObservable();
    }
    show() {
      this.pendingRequestsInterceptorConfigurer.forceByPass = true;
      this._visibility$.next(true);
    }
    hide() {
      this._visibility$.next(false);
      this.pendingRequestsInterceptorConfigurer.forceByPass = false;
    }
    static ɵfac = function SpinnerVisibilityService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SpinnerVisibilityService)(i0.ɵɵinject(PendingRequestsInterceptorConfigurer));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SpinnerVisibilityService,
      factory: SpinnerVisibilityService.ɵfac,
      providedIn: 'root'
    });
  }
  return SpinnerVisibilityService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
let NgHttpLoaderComponent = /*#__PURE__*/(() => {
  class NgHttpLoaderComponent {
    pendingRequestsInterceptorConfigurer;
    spinnerVisibility;
    spinkit = Spinkit;
    isVisible$;
    visibleUntil = Date.now();
    backdrop = true;
    backgroundColor;
    debounceDelay = 0;
    entryComponent;
    extraDuration = 0;
    filteredHeaders = [];
    filteredMethods = [];
    filteredUrlPatterns = [];
    minDuration = 0;
    opacity = '.7';
    backdropBackgroundColor = '#f1f1f1';
    spinner = Spinkit.skWave;
    constructor(pendingRequestsInterceptorConfigurer, spinnerVisibility) {
      this.pendingRequestsInterceptorConfigurer = pendingRequestsInterceptorConfigurer;
      this.spinnerVisibility = spinnerVisibility;
    }
    ngOnInit() {
      this.initIsvisibleObservable();
      this.nullifySpinnerIfEntryComponentIsDefined();
      this.initFilters();
    }
    initIsvisibleObservable() {
      const [showSpinner$, hideSpinner$] = partition(this.pendingRequestsInterceptorConfigurer.pendingRequestsStatus$, h => h);
      this.isVisible$ = merge(this.pendingRequestsInterceptorConfigurer.pendingRequestsStatus$.pipe(switchMap(() => showSpinner$.pipe(debounce(() => timer(this.debounceDelay))))), showSpinner$.pipe(switchMap(() => hideSpinner$.pipe(debounce(() => this.getVisibilityTimer$())))), this.spinnerVisibility.visibility$).pipe(distinctUntilChanged(), tap(h => this.updateExpirationDelay(h)));
    }
    nullifySpinnerIfEntryComponentIsDefined() {
      if (this.entryComponent) {
        this.spinner = null;
      }
    }
    initFilters() {
      this.initFilteredUrlPatterns();
      this.initFilteredMethods();
      this.initFilteredHeaders();
    }
    initFilteredUrlPatterns() {
      if (!!this.filteredUrlPatterns.length) {
        this.filteredUrlPatterns.forEach(e => this.pendingRequestsInterceptorConfigurer.filteredUrlPatterns.push(new RegExp(e)));
      }
    }
    initFilteredMethods() {
      this.pendingRequestsInterceptorConfigurer.filteredMethods = this.filteredMethods;
    }
    initFilteredHeaders() {
      this.pendingRequestsInterceptorConfigurer.filteredHeaders = this.filteredHeaders;
    }
    updateExpirationDelay(showSpinner) {
      if (showSpinner) {
        this.visibleUntil = Date.now() + this.minDuration;
      }
    }
    getVisibilityTimer$() {
      return timer(Math.max(this.extraDuration, this.visibleUntil - Date.now()));
    }
    static ɵfac = function NgHttpLoaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgHttpLoaderComponent)(i0.ɵɵdirectiveInject(PendingRequestsInterceptorConfigurer), i0.ɵɵdirectiveInject(SpinnerVisibilityService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NgHttpLoaderComponent,
      selectors: [["ng-http-loader"]],
      inputs: {
        backdrop: "backdrop",
        backgroundColor: "backgroundColor",
        debounceDelay: "debounceDelay",
        entryComponent: "entryComponent",
        extraDuration: "extraDuration",
        filteredHeaders: "filteredHeaders",
        filteredMethods: "filteredMethods",
        filteredUrlPatterns: "filteredUrlPatterns",
        minDuration: "minDuration",
        opacity: "opacity",
        backdropBackgroundColor: "backdropBackgroundColor",
        spinner: "spinner"
      },
      decls: 2,
      vars: 3,
      consts: [["id", "spinner", 3, "backdrop", "opacity", "ngStyle", 4, "ngIf"], ["id", "spinner", 3, "ngStyle"], [4, "ngComponentOutlet"], [3, "backgroundColor", 4, "ngIf"], [3, "backgroundColor"]],
      template: function NgHttpLoaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, NgHttpLoaderComponent_div_0_Template, 10, 16, "div", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.isVisible$));
        }
      },
      dependencies: [SkCubeGridComponent, SkChasingDotsComponent, SkDoubleBounceComponent, SkRotatingPlaneComponent, SkSpinnerPulseComponent, SkThreeBounceComponent, SkWanderingCubesComponent, SkWaveComponent, NgStyle, NgComponentOutlet, NgIf, AsyncPipe],
      styles: ["#spinner[_ngcontent-%COMP%]{top:50%;left:50%;transform:translate(-50%,-50%);position:fixed;z-index:9999}#spinner.backdrop[_ngcontent-%COMP%]{top:0;left:0;height:100%;width:100%;display:flex;align-items:center;justify-content:center;transform:none}  .colored-parent,   .colored>div{background-color:#333}"]
    });
  }
  return NgHttpLoaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
function pendingRequestsInterceptor$(req, next) {
  const pendingRequestsInterceptorConfigurer = inject(PendingRequestsInterceptorConfigurer);
  const shouldBypass = pendingRequestsInterceptorConfigurer.shouldBypass(req);
  if (!shouldBypass) {
    pendingRequestsInterceptorConfigurer.pendingRequests++;
    if (1 === pendingRequestsInterceptorConfigurer.pendingRequests) {
      pendingRequestsInterceptorConfigurer.pendingRequestsStatusSubject$.next(true);
    }
  }
  return next(req).pipe(finalize(() => {
    if (!shouldBypass) {
      pendingRequestsInterceptorConfigurer.pendingRequests--;
      if (0 === pendingRequestsInterceptorConfigurer.pendingRequests) {
        pendingRequestsInterceptorConfigurer.pendingRequestsStatusSubject$.next(false);
      }
    }
  }));
}

/*
 * Public API Surface of ng-http-loader
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractLoaderDirective, NgHttpLoaderComponent, PendingRequestsInterceptorConfigurer, SPINKIT_COMPONENTS, SkChasingDotsComponent, SkCubeGridComponent, SkDoubleBounceComponent, SkRotatingPlaneComponent, SkSpinnerPulseComponent, SkThreeBounceComponent, SkWanderingCubesComponent, SkWaveComponent, Spinkit, SpinnerVisibilityService, pendingRequestsInterceptor$ };
